<template>
  <router-link
    :to="url"
    class="item"
  >
    <i v-if="!!this.icon" />
    {{ title }}
  </router-link>
</template>

<script>
import navigationItem from '@/components/shared/NavigationItem'
export default {
  name: 'NavigationButton',
  mixins: [navigationItem],
}
</script>

<style scoped>
  .router-link-active {
    transition: border 200ms ease;
    border-bottom: 2px solid #fff;
  }
</style>
